<template>
  <div class="loading"></div>
</template>

<script>
export default {
  name: "noteLoadPage",
};
</script>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
  background-color: white;
}
</style>
